import React, { Component } from 'react';
import i18n from '../i18n';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AccessLevelsActions from '../redux/AccessLevelsRedux';
import AjaxActions from '../redux/AjaxRedux';
import SitesActions from '../redux/SitesRedux';
import SchedulesActions from '../redux/SchedulesRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import Modal from '../components/common/Modal';
import AccessLevelDetails from '../components/accessLevelsElements/AccessLevelDetails';
import AddDoorsModal from '../components/accessLevelsElements/AddDoorsModal';
import AddAjaxModal from '../components/accessLevelsElements/AddAjaxModal';
import Global from '../lib/Global';
import differenceBy from 'lodash/differenceBy';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class AccessLevels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      // accessLevels page params
      accessLevelsItemsPerPage: 10,
      accessLevelsPageNumber: 0,
      accessLevelsSearchValue: null,
      accessLevelsSortDirection: 'ASC',
      // accessLevels details
      hideDetails: true,
      isNewAccessLevel: false,
      accessLevelId: null,
      name: '',
      description: '',
      scheduleNameId: '',
      externalName: null,
      // access levels Form Errors:
      isUntouched: true,
      // add Ajax modal
      checkedHubs: [],
      checkedGroups: [],
      isAjaxModalOpen: false,
      // add doors modal
      doors: [],
      checkedDoors: [],
      isDoorsModalOpen: false,
      doorsItemsPerPage: 10,
      doorsPageNumber: 0,
      doorsSearchValue: null,
      extendedSchedule: false,
      extendedSelectedSchedule: false,
    };
  }

  componentDidMount() {
    if (this.props.customerId && Global.api.accessToken) {
      this.sendGetAccessLevelsRequest();
      this.sendGetSchedules();
      if (this.props.hasAjax) {
        this.props.loginAjax(this.props.customerId);
      }
    }
  }

  componentWillUnmount() {
    this.props.resetAccessLevels();
    this.props.resetControllers();
    this.props.resetSchedules();
  }

  componentDidUpdate(prevProps) {
    const {
      customerId,
      hasAjax,
      ajaxUserId,
      hubs,
      getHubs,
      getHubDetails,
      getGroups,
      ajaxAccessLevelLinks,
    } = this.props;
    if (hasAjax) {
      if (ajaxUserId && ajaxUserId !== prevProps.ajaxUserId) {
        getHubs(customerId, ajaxUserId);
      }
      if (hubs.length > 0 && hubs.length !== prevProps.hubs.length) {
        hubs.forEach((hub) => getHubDetails(customerId, ajaxUserId, hub.hubId));
      }
      // only if all hubs have details, get groups if groupsEnabled
      if (prevProps.hubs !== hubs && hubs.every((hub) => hub.hasDetails)) {
        const hubsWithGroupsEnabled = hubs.filter((hub) => hub.groupsEnabled);
        hubsWithGroupsEnabled.forEach((hub) => getGroups(customerId, ajaxUserId, hub.hubId, hub.hubIndex));
      }
    }
    if (prevProps.customerId !== customerId) {
      this.props.resetAccessLevels();
      this.props.resetControllers();
      this.props.resetSchedules();
      this.resetAccessLevelFormFields();
      if (customerId) {
        this.sendGetAccessLevelsRequest();
        this.sendGetSchedules();
      }
    }
    if (prevProps.accessLevelsIsLoading && !this.props.accessLevelsIsLoading) {
      if (this.props.accessLevelsSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.accessLevelsSuccessMessage,
        });
      }
      if (this.props.accessLevelsErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.accessLevelsErrorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({ accessLevelId: this.props.createdId, isNewAccessLevel: false, isUntouched: true });
      }
    }
    if (prevProps.ajaxAccessLevelLinks !== ajaxAccessLevelLinks) {
      const ajaxLinkedHubs = ajaxAccessLevelLinks.filter((groupOrHub) => !groupOrHub.groupId);
      const ajaxLinkedGroups = ajaxAccessLevelLinks.filter((groupOrHub) => groupOrHub.groupId);
      this.setState({ checkedHubs: ajaxLinkedHubs, checkedGroups: ajaxLinkedGroups });
    }
    if (prevProps.ajaxIsLoading && !this.props.ajaxIsLoading) {
      if (this.props.ajaxSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.ajaxSuccessMessage,
        });
      }
      if (this.props.ajaxErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.ajaxErrorMessage,
        });
      }
    }
  }

  // accessLevels list table methods

  sendGetAccessLevelsRequest() {
    const pageParams = {
      items: this.state.accessLevelsItemsPerPage,
      page: this.state.accessLevelsPageNumber,
      value: this.state.accessLevelsSearchValue,
      sort: this.state.accessLevelsSortDirection,
    };
    this.props.getAccessLevels(this.props.customerId, pageParams);
  }

  sendGetSchedules() {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
      sort: 'ASC',
    };
    this.props.getSchedules(this.props.customerId, pageParams);
  }

  changeaccessLevelsItemsPerPage = (accessLevelsItemsPerPage) => {
    this.setState({ accessLevelsItemsPerPage, accessLevelsPageNumber: 0 }, () => this.sendGetAccessLevelsRequest());
  };

  changeaccessLevelsPage = (accessLevelsPageNumber) => {
    this.setState({ accessLevelsPageNumber }, () => this.sendGetAccessLevelsRequest());
  };

  handleSearchAccessLevel = (accessLevelsSearchValue) => {
    this.setState({ accessLevelsSearchValue, accessLevelsPageNumber: 0 }, () => this.sendGetAccessLevelsRequest());
    this.resetAccessLevelFormFields();
  };

  handleSortAccessLevel = (accessLevelsSortBy, accessLevelsSortDirection) => {
    this.setState({ accessLevelsSortDirection, accessLevelsPageNumber: 0 }, () => this.sendGetAccessLevelsRequest());
    this.resetAccessLevelFormFields();
  };

  handleSearchAccessLevelKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchAccessLevel(value);
    }
  };

  selectAccessLevel = (accessLevel) => {
    this.resetAccessLevelFormFields();
    let accessLevelId = accessLevel.accessLevelId ? accessLevel.accessLevelId : null,
      name = accessLevel.name ? accessLevel.name : '',
      description = accessLevel.description ? accessLevel.description : '',
      scheduleNameId = accessLevel.scheduleNameId ? accessLevel.scheduleNameId : '',
      externalName = accessLevel.externalName;
    this.setState(
      { hideDetails: false, isNewAccessLevel: false, accessLevelId, name, description, scheduleNameId, externalName },
      () => {
        this.sendGetControllersRequest();
        this.props.hasAjax && this.props.getAjaxAccessLevelLinks(accessLevel.accessLevelId);
      }
    );
    this.isExtendedScheduleById(scheduleNameId, false);
    this.isExtendedScheduleById(scheduleNameId, true);
  };

  isExtendedScheduleById = (scheduleNameId, selected) => {
    if (scheduleNameId !== '') {
      const scheduleName = this.props.schedules.find((element) => element.scheduleNameId === scheduleNameId);
      const newState = this.isExtendedSchedule(scheduleName);
      if (selected) {
        this.setState({ extendedSelectedSchedule: newState });
      } else {
        this.setState({ extendedSchedule: newState });
      }
    }
  };
  isExtendedSchedule = (scheduleName) => {
    if (scheduleName) {
      const newState = scheduleName.schedules.length > 7;
      return newState;
    }
    return false;
  };

  // accessLevel details form methods

  resetAccessLevelFormFields = () => {
    this.setState({
      accessLevelId: null,
      name: '',
      description: '',
      scheduleNameId: '',
      isUntouched: true,
      externalName: null,
    });
    this.props.resetControllers();
  };

  handleAddAccessLevel = () => {
    this.resetAccessLevelFormFields();
    this.props.resetAjaxAccessLevelLinks();
    this.setState({ hideDetails: false, accessLevelsSearchValue: null, isNewAccessLevel: true });
  };

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleAccessLevelDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.usersSearchValue) {
        return this.handleSaveAccessLevel();
      }
    }
  };

  handleSaveAccessLevel = () => {
    const { accessLevelId, name, description, scheduleNameId, externalName } = this.state;
    const accessLevelInfos = {
      name,
      description,
      scheduleNameId,
      customerId: this.props.customerId,
      externalName,
    };
    const editAccessLevelInfos = { ...accessLevelInfos, accessLevelId };
    const pageParams = {
      items: this.state.accessLevelsItemsPerPage,
      page: this.state.accessLevelsPageNumber,
      value: this.state.accessLevelsSearchValue,
      sort: this.state.accessLevelsSortDirection,
    };
    this.state.isNewAccessLevel
      ? this.props.createAccessLevel(accessLevelInfos, this.props.customerId, pageParams)
      : this.props.editAccessLevel(editAccessLevelInfos, this.props.customerId, pageParams);
    this.isExtendedScheduleById(scheduleNameId, false);
  };

  openDeleteAccessLevelAlert = () => {
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteAccessLevelTitle'),
      alertContentText: i18n.t('accessLevelManager_confirmDelete', { name: this.state.name }),
      alertConfirmAction: this.deleteAccessLevel,
    });
  };

  deleteAccessLevel = () => {
    const pageParams = {
      items: this.state.accessLevelsItemsPerPage,
      page: this.state.accessLevelsPageNumber,
      value: this.state.accessLevelsSearchValue,
      sort: this.state.accessLevelsSortDirection,
    };
    this.props.deleteAccessLevel(this.state.accessLevelId, this.props.customerId, pageParams);
    this.resetAccessLevelFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  // controllers (= doors) methods

  sendGetControllersRequest() {
    this.props.getAccessLevelControllers(this.state.accessLevelId);
  }

  openDeleteControllerAlert = (controller) => {
    this.selectController(controller);
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteDoorTitle'),
      alertContentText: i18n.t('accessLevelManager_confirmControllerDelete', {
        name: controller.name,
      }),
      alertConfirmAction: () => this.deleteController(controller),
    });
  };

  deleteController = (controller) => {
    const data = [controller.controllerId];
    this.props.deleteController(this.state.accessLevelId, data);
    this.setState({ isAlertDialogOpen: false });
  };

  selectController = (controller) => {
    const { name, controllerId } = controller;
    this.setState({ controllerName: name, tempControllerName: name, controllerId });
  };

  // Ajax methods

  openDeleteAjaxAlert = (link) => {
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.removeAjaxAccessLevelLinkTitle'),
      alertContentText: i18n.t('alert.removeAjaxAccessLevelLinkContent', {
        name: link.name,
      }),
      alertConfirmAction: () => this.deleteAjaxLink(link),
    });
  };

  deleteAjaxLink = (link) => {
    this.props.deleteAjaxAccessLevelLink(link.id, this.state.accessLevelId);
    this.setState({ isAlertDialogOpen: false });
  };

  closeAjaxModalWithoutSave = () => {
    const ajaxLinkedHubs = this.props.ajaxAccessLevelLinks.filter((groupOrHub) => !groupOrHub.groupId);
    const ajaxLinkedGroups = this.props.ajaxAccessLevelLinks.filter((groupOrHub) => groupOrHub.groupId);
    this.setState({ checkedHubs: ajaxLinkedHubs, checkedGroups: ajaxLinkedGroups, isAjaxModalOpen: false });
  };

  saveAjax = () => {
    const { ajaxAccessLevelLinks } = this.props;
    const { accessLevelId } = this.state;
    const hubsLinks = this.state.checkedHubs.map(({ hubId }) => {
      const linkId = ajaxAccessLevelLinks.find((link) => link.hubId === hubId && !link.groupId)?.id;
      return { accessLevelId, hubId, id: linkId };
    });
    const groupsLinks = this.state.checkedGroups.map(({ groupId, hubId }) => {
      const linkId = ajaxAccessLevelLinks.find((link) => link.hubId === hubId && link.groupId === groupId)?.id;
      return { accessLevelId, hubId, groupId, id: linkId };
    });
    const updatedAjaxAccessLevelLinks = hubsLinks.concat(groupsLinks);
    const linksRemoved = differenceBy(ajaxAccessLevelLinks, updatedAjaxAccessLevelLinks, 'id');
    const linksAdded = differenceBy(updatedAjaxAccessLevelLinks, ajaxAccessLevelLinks, 'id');
    if (linksRemoved.length > 0) {
      const ajaxLinkedHubs = this.props.ajaxAccessLevelLinks.filter((groupOrHub) => !groupOrHub.groupId);
      const ajaxLinkedGroups = this.props.ajaxAccessLevelLinks.filter((groupOrHub) => groupOrHub.groupId);
      return this.setState({
        isAlertDialogOpen: true,
        alertTitle: 'Warning',
        alertContentText: 'Ajax links can only be removed by pressing the X button on the right',
        alertConfirmAction: null,
        checkedHubs: ajaxLinkedHubs,
        checkedGroups: ajaxLinkedGroups,
        isAjaxModalOpen: false,
      });
    }
    if (linksAdded.length > 0) {
      this.props.updateAjaxAccessLevelLinks(updatedAjaxAccessLevelLinks, accessLevelId);
    }
    this.setState({ isAjaxModalOpen: false });
  };

  // Doors modal methods

  handleAddDoor = () => {
    this.sendGetDoorsRequest();
    this.setState({ doorsSearchValue: null, isDoorsModalOpen: true });
  };

  sendGetDoorsRequest() {
    const getDoorsParams = {
      items: this.state.doorsItemsPerPage,
      page: this.state.doorsPageNumber,
      value: this.state.doorsSearchValue,
    };
    this.props.getCustomerControllers(this.props.customerId, getDoorsParams);
  }

  changeDoorsItemsPerPage = (doorsItemsPerPage) => {
    this.setState({ doorsItemsPerPage, doorsPageNumber: 0 }, () => this.sendGetDoorsRequest());
  };

  changeDoorsPage = (doorsPageNumber) => {
    this.setState({ doorsPageNumber }, () => this.sendGetDoorsRequest());
  };

  handleSearchDoor = (doorsSearchValue) => {
    this.setState({ doorsSearchValue, doorsPageNumber: 0 }, () => this.sendGetDoorsRequest());
  };

  handleSearchDoorKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchDoor(value);
    }
  };

  handleChecked = (item, checkedCategory, idName) => {
    const previousChecked = this.state[checkedCategory];
    const selectedIndex = previousChecked.findIndex((prop) => item[idName] === prop[idName]);
    let newChecked = [];

    if (selectedIndex === -1) {
      // if not found, add it
      newChecked = newChecked.concat(previousChecked, item);
    } else if (selectedIndex === 0) {
      // if first item, remove it
      newChecked = newChecked.concat(previousChecked.slice(1));
    } else if (selectedIndex === previousChecked.length - 1) {
      // if last item, remove it
      newChecked = newChecked.concat(previousChecked.slice(0, -1));
    } else if (selectedIndex > 0) {
      // if between first and last, remove it
      newChecked = newChecked.concat(previousChecked.slice(0, selectedIndex), previousChecked.slice(selectedIndex + 1));
    }
    this.setState({ [checkedCategory]: newChecked });
  };

  closeDoorsModalWithoutSave = () => {
    this.setState({ checkedDoors: [], isDoorsModalOpen: false });
  };

  saveDoors = () => {
    const data = this.state.checkedDoors.map(({ controllerId }) => controllerId);
    this.props.addControllersToAccessLevel(this.state.accessLevelId, data);
    this.setState((prevState) => ({ doors: prevState.checkedDoors, isDoorsModalOpen: false, checkedDoors: [] }));
  };

  isControllerExtendedScheduleCapability = (controller) => {
    const capability = controller.capabilities.split(';');
    return capability.some((element) => element === 'extendedSchedule');
  };

  getControllerExtendedScheduleCapability = (controller) => {
    return (
      this.isControllerExtendedScheduleCapability(controller) ||
      (!this.state.extendedSchedule && !this.state.extendedSelectedSchedule)
    );
  };

  getExtendedScheduleCapability = (schedule) => {
    const isExtended = this.isExtendedSchedule(schedule);
    let isExtendedCap = true;
    this.props.accessLevelControllers.forEach((controller) => {
      if (!this.isControllerExtendedScheduleCapability(controller)) {
        isExtendedCap = false;
      }
    });
    return isExtendedCap === isExtended || !isExtended;
  };

  handleScheduleChange = (scheduleNameId) => {
    this.setState({ scheduleNameId });
    this.isExtendedScheduleById(scheduleNameId, true);
  };

  isExternalNameSet = (externalName) => {
    if (externalName == null || externalName == '') {
      return false;
    }
    return true;
  };

  render() {
    const { t, classes, width, hasAjax, ajaxAccessLevelLinks, hubs, groups } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const accessLevelsData = cloneDeep(this.props.accessLevels); //this is necessary for table to work
    const controllersInitialData = cloneDeep(this.props.accessLevelControllers);
    const controllersData = controllersInitialData
      ? controllersInitialData.map((controller) => {
          return {
            ...controller,
            nameDescription: `${controller.name ? controller.name : ''} ${
              controller.description ? controller.description : ''
            }`,
          };
        })
      : null;
    const allControllersInitialData = cloneDeep(this.props.customerControllers);
    const allControllersData = allControllersInitialData
      ? allControllersInitialData
          .filter(({ controllerId }) =>
            this.props.accessLevelControllers.every((door) => door.controllerId !== controllerId)
          )
          .map((controller) => {
            return {
              capability: this.getControllerExtendedScheduleCapability(controller),
              ...controller,
            };
          })
      : null;

    const schedulesInitialData = cloneDeep(this.props.schedules);
    const schedulesData = schedulesInitialData
      ? schedulesInitialData.map((schedule) => {
          return {
            ...schedule,
            capability: this.getExtendedScheduleCapability(schedule),
          };
        })
      : null;
    const availableGroups = this.props.groups.map((group) => ({ ...group, name: group.groupName, groupId: group.id }));
    const linkedAjaxData = ajaxAccessLevelLinks.map((hubOrGroup) => {
      if (!hubOrGroup.groupId) {
        const matchingHub = hubs.find((hub) => hub.hubId === hubOrGroup.hubId);
        if (matchingHub) {
          return { ...hubOrGroup, name: matchingHub.name };
        }
      } else {
        const matchingGroup = availableGroups.find(
          (group) => group.hubId === hubOrGroup.hubId && group.id === hubOrGroup.groupId
        );
        if (matchingGroup) {
          return { ...hubOrGroup, name: matchingGroup.name };
        }
      }
      return hubOrGroup;
    });

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t('Global_delete')}
          onConfirm={this.state.alertConfirmAction}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        {/* add Ajax link modal */}
        <Modal
          open={this.state.isAjaxModalOpen}
          handleClose={this.closeAjaxModalWithoutSave}
          Content={AddAjaxModal}
          onClickSave={this.saveAjax}
          checkboxColumn="start"
          hubsData={this.props.hubs}
          groupsData={availableGroups}
          handleHubClick={(hub) => this.handleChecked(hub, 'checkedHubs', 'hubId')}
          handleGroupClick={(group) => this.handleChecked(group, 'checkedGroups', 'groupId')}
          columns={[{ title: t('common.name'), field: 'name' }]}
          noHeader
          noTableHead
          noFooter
          hubsCheckedArray={this.state.checkedHubs}
          groupsCheckedArray={this.state.checkedGroups}
          page={this.state.doorsPageNumber}
        />
        {/* add doors modal */}
        <Modal
          open={this.state.isDoorsModalOpen}
          handleClose={this.closeDoorsModalWithoutSave}
          enableCapabilityFilter
          Content={AddDoorsModal}
          onClickSave={this.saveDoors}
          // search access levels table props
          checkboxColumn="start"
          data={allControllersData}
          noDataText={t('sites.noDoor')}
          handleClick={(door) => this.handleChecked(door, 'checkedDoors', 'controllerId')}
          columns={[
            // { title: t('siteManager_controllers_col1'), field: 'controllerUid' },
            { title: t('siteManager_controllers_col2'), field: 'controllerName' },
          ]}
          handleSearch={this.handleSearchDoor}
          activeRowField={'controllerId'}
          checkedArray={this.state.checkedDoors}
          searchPlaceholder={t('doorControlManager_addControllersModal_searchControllers')}
          itemsPerPage={this.state.doorsItemsPerPage}
          changeItemsPerPage={this.changeDoorsItemsPerPage}
          totalElements={this.props.customerControllersTotal}
          page={this.state.doorsPageNumber}
          changePage={this.changeDoorsPage}
          onKeyPress={this.handleSearchDoorKeyPress}
          // rows per page select props
          selectData={[5, 10, 20]}
          selectLabel={t('table.showPerPage')}
          selectValue={this.state.doorsItemsPerPage}
          onSelect={this.changeDoorsItemsPerPage}
          selectWidth={90}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={accessLevelsData}
                noDataText={t('accessLevels.noAccessLevel')}
                handleClick={(value) => this.selectAccessLevel(value)}
                columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
                activeRowValue={this.state.accessLevelId}
                activeRowField={'accessLevelId'}
                handleSearch={this.handleSearchAccessLevel}
                sortBy={'name'}
                sortDirection={this.state.accessLevelsSortDirection}
                handleSort={this.handleSortAccessLevel}
                searchPlaceholder={t('accessLevels.searchAccessLevel')}
                itemsPerPage={this.state.accessLevelsItemsPerPage}
                changeItemsPerPage={this.changeaccessLevelsItemsPerPage}
                totalElements={this.props.accessLevelsTotalElements}
                page={this.state.accessLevelsPageNumber}
                changePage={this.changeaccessLevelsPage}
                onKeyPress={this.handleSearchAccessLevelKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.accessLevelsItemsPerPage}
                onSelect={this.changeaccessLevelsItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <AccessLevelDetails
                copyable
                // Ajax
                hasAjax={hasAjax}
                ajaxColumns={[{ title: t('common.name'), field: 'name' }]}
                ajaxData={linkedAjaxData}
                onAddHubsButtonClick={() => this.setState({ isAjaxModalOpen: true })}
                handleAjaxDeleteButtonClick={(link) => this.openDeleteAjaxAlert(link)}
                // buttons
                add1ButtonText={t('accessLevelManager_addNewAccessLevel')}
                add2ButtonText={t('accessLevelManager_addControllersToALevel')}
                add2ButtonDisabled={this.state.isNewAccessLevel}
                onDeleteButtonClick={this.openDeleteAccessLevelAlert}
                onAdd1ButtonClick={this.handleAddAccessLevel}
                onAdd2ButtonClick={this.handleAddDoor}
                onSaveButtonClick={this.handleSaveAccessLevel}
                isDeleteButtonDisabled={
                  !this.state.accessLevelId ||
                  this.state.isNewAccessLevel ||
                  this.isExternalNameSet(this.state.externalName)
                }
                // details form
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                accessLevelId={this.state.accessLevelId}
                name={this.state.name}
                description={this.state.description}
                // schedules select
                schedulesSelectData={schedulesData}
                schedulesSelectLabel={t('accessLevelManager_aLevelInfo_scheduleName')}
                schedulesAccessValue={'scheduleNameId'}
                schedulesAccessLabel={'name'}
                schedulesSelectValue={this.state.scheduleNameId}
                schedulesOnSelect={this.handleScheduleChange}
                enableCapabilityFilter={true}
                // form and validations
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                // controllers/doors table
                tableTitle={t('accessLevelManager_controllers_header')}
                controllersData={controllersData}
                columns={[
                  { title: t('siteManager_controllers_col1'), field: 'controllerUid' },
                  { title: t('siteManager_controllers_col2'), field: 'nameDescription' },
                ]}
                noDataText={t('sites.noDoor')}
                handleClick={null}
                deleteColumn
                handleDoorsDeleteButtonClick={(door) => this.openDeleteControllerAlert(door)}
                totalElements={this.props.tagsTotalElements}
                page={this.state.tagsPageNumber}
                noHeader
                noFooter
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    //accessLevels
    accessLevels: state.accessLevels.accessLevels,
    accessLevelsTotalElements: state.accessLevels.totalElements,
    createdId: state.accessLevels.createdId,
    accessLevelsIsLoading: state.accessLevels.isLoading,
    accessLevelsSuccessMessage: state.accessLevels.successMessage,
    accessLevelsErrorMessage: state.accessLevels.errorMessage,
    // ajax
    hasAjax: state.auth.hasAjax,
    ajaxUserId: state.ajax.userId,
    hubs: state.ajax.hubs,
    groups: state.ajax.groups,
    ajaxIsLoading: state.ajax.isLoading,
    ajaxErrorMessage: state.ajax.errorMessage,
    ajaxSuccessMessage: state.ajax.successMessage,
    ajaxAccessLevelLinks: state.ajax.ajaxAccessLevelLinks,
    // controllers
    accessLevelControllers: state.accessLevels.accessLevelControllers,
    customerControllers: state.sites.customerControllers,
    customerControllersTotal: state.sites.customerControllersTotal,
    // schedules
    schedules: state.schedules.schedules,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // accessLevels
  getAccessLevels: (customerId, pageParams) =>
    dispatch(AccessLevelsActions.getAccessLevelsRequest(customerId, pageParams)),
  createAccessLevel: (accessLevelInfos, customerId, pageParams) =>
    dispatch(AccessLevelsActions.createAccessLevelRequest(accessLevelInfos, customerId, pageParams)),
  editAccessLevel: (accessLevelInfos, customerId, pageParams) =>
    dispatch(AccessLevelsActions.editAccessLevelRequest(accessLevelInfos, customerId, pageParams)),
  deleteAccessLevel: (accessLevelId, customerId, pageParams) =>
    dispatch(AccessLevelsActions.deleteAccessLevelRequest(accessLevelId, customerId, pageParams)),
  resetAccessLevels: () => dispatch(AccessLevelsActions.resetAccessLevels()),
  // Ajax
  loginAjax: (customerId) => dispatch(AjaxActions.loginAjaxRequest(customerId)),
  resetAjaxAccessLevelLinks: () => dispatch(AjaxActions.resetAjaxAccessLevelLinks()),
  getHubs: (customerId, userId) => dispatch(AjaxActions.getHubsRequest(customerId, userId)),
  getHubDetails: (customerId, userId, hubId) => dispatch(AjaxActions.getHubDetailsRequest(customerId, userId, hubId)),
  getGroups: (customerId, userId, hubId, hubIndex) =>
    dispatch(AjaxActions.getGroupsRequest(customerId, userId, hubId, hubIndex)),
  getAjaxAccessLevelLinks: (accessLevelId) => dispatch(AjaxActions.getAjaxAccessLevelLinksRequest(accessLevelId)),
  updateAjaxAccessLevelLinks: (ajaxAccessLevelLinks, accessLevelId) =>
    dispatch(AjaxActions.updateAjaxAccessLevelLinksRequest(ajaxAccessLevelLinks, accessLevelId)),
  deleteAjaxAccessLevelLink: (ajaxAccessLevelLinkId, accessLevelId) =>
    dispatch(AjaxActions.deleteAjaxAccessLevelLinkRequest(ajaxAccessLevelLinkId, accessLevelId)),

  // controllers
  getAccessLevelControllers: (accessLevelId) =>
    dispatch(AccessLevelsActions.getAccessLevelControllersRequest(accessLevelId)),
  resetControllers: () => dispatch(AccessLevelsActions.resetControllers()),
  getCustomerControllers: (customerId, pageParams) =>
    dispatch(SitesActions.getCustomerControllersRequest(customerId, pageParams)),
  addControllersToAccessLevel: (accessLevelId, controllers) =>
    dispatch(AccessLevelsActions.addControllersToAccessLevelRequest(accessLevelId, controllers)),
  deleteController: (accessLevelId, controllers) =>
    dispatch(AccessLevelsActions.deleteAccessLevelControllersRequest(accessLevelId, controllers)),

  // schedules
  getSchedules: (customerId, pageParams) => dispatch(SchedulesActions.getSchedulesRequest(customerId, pageParams)),
  resetSchedules: () => dispatch(SchedulesActions.resetSchedules()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(AccessLevels);
